import { translate } from 'react-switch-lang';
import { Fragment, useCallback, useEffect, useState } from 'react';
import { FormGroup } from 'reactstrap';
import { useHttpClient } from '../../../../../security/hooks/axiosProvider';
import { natureCharge as natureChargeModel } from '../../../model/types';

const DetailNatureCharge = (props) => {
  const [charge, setCharge] = useState(natureChargeModel);
  const httpClient = useHttpClient(true);

  const getCharge = useCallback(async () => {
    if (props.charge.id !== undefined) {
      httpClient.current?.get(`/api/naturecharge/${props.charge.id}`).then((response) => {
        setCharge(response.data);
      });
    }
  }, [httpClient, props.charge.id]);

  useEffect(() => {
    getCharge();
  }, [getCharge]);

  return (
    <>
      <Fragment>
        <form className="needs-validation" noValidate>
          <FormGroup className="form-row">
            <label htmlFor="charge_name">{props.t('charge_name')}</label>
            <input type="text" className="form-control" name="name" id="unit_name" value={charge.name} disabled />
          </FormGroup>
          <FormGroup className="form-row">
            <label htmlFor="unit_description">{props.t('Description')}</label>
            <textarea value={charge.description} className="form-control" id="unit_description" rows={3} disabled />
          </FormGroup>
          <FormGroup className="form-row">
            <label htmlFor={'charge_activity'}>{props.t('charge_activity_name')}</label>
            <select name="activity" id="charge_activity" className="form-control" disabled>
              <option>{charge.activity.name}</option>
            </select>
          </FormGroup>
        </form>
      </Fragment>
    </>
  );
};
export default translate(DetailNatureCharge);
